module.exports = __webpack_public_path__ + "img/sleeve_opening.7498c87a.png";